var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 492,
    viewBox: "0 0 700 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 698,
    height: 490,
    rx: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 146,
    width: 40,
    height: 301,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 40,
    height: 176,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 215,
    width: 40,
    height: 232,
    rx: 10,
    fill: "#FB6C21"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 40,
    height: 209,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 185,
    width: 40,
    height: 262,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 40,
    height: 307,
    rx: 10,
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 254,
    width: 40,
    height: 193,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 226,
    width: 40,
    height: 221,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.61 53V35.84H210.39V53H206.61ZM217.254 53V38.93H211.614V35.84H226.674V38.93H221.034V53H217.254ZM231.928 53L239.728 35.84H243.478L251.248 53H247.498L240.958 37.76H242.218L235.618 53H231.928ZM235.798 49.28L236.818 46.4H245.758L246.778 49.28H235.798ZM252.202 53V35.84H255.322L265.672 48.38H264.262V35.84H268.012V53H264.892L254.542 40.46H255.982V53H252.202ZM271.737 53V35.84H279.507C281.467 35.84 283.157 36.19 284.577 36.89C286.017 37.59 287.127 38.59 287.907 39.89C288.707 41.17 289.107 42.68 289.107 44.42C289.107 46.18 288.707 47.7 287.907 48.98C287.127 50.26 286.017 51.25 284.577 51.95C283.157 52.65 281.467 53 279.507 53H271.737ZM275.517 49.94H279.387C280.607 49.94 281.657 49.72 282.537 49.28C283.417 48.84 284.097 48.21 284.577 47.39C285.057 46.57 285.297 45.58 285.297 44.42C285.297 43.26 285.057 42.27 284.577 41.45C284.097 40.63 283.417 40.01 282.537 39.59C281.657 39.15 280.607 38.93 279.387 38.93H275.517V49.94ZM298.21 53V35.84H305.98C307.94 35.84 309.63 36.19 311.05 36.89C312.49 37.59 313.6 38.59 314.38 39.89C315.18 41.17 315.58 42.68 315.58 44.42C315.58 46.18 315.18 47.7 314.38 48.98C313.6 50.26 312.49 51.25 311.05 51.95C309.63 52.65 307.94 53 305.98 53H298.21ZM301.99 49.94H305.86C307.08 49.94 308.13 49.72 309.01 49.28C309.89 48.84 310.57 48.21 311.05 47.39C311.53 46.57 311.77 45.58 311.77 44.42C311.77 43.26 311.53 42.27 311.05 41.45C310.57 40.63 309.89 40.01 309.01 39.59C308.13 39.15 307.08 38.93 305.86 38.93H301.99V49.94ZM317.891 53V35.84H321.671V53H317.891ZM340.385 51.11C339.805 51.57 339.135 51.97 338.375 52.31C337.635 52.63 336.855 52.87 336.035 53.03C335.215 53.21 334.385 53.3 333.545 53.3C331.705 53.3 330.055 52.92 328.595 52.16C327.155 51.38 326.025 50.32 325.205 48.98C324.385 47.64 323.975 46.12 323.975 44.42C323.975 42.72 324.385 41.21 325.205 39.89C326.025 38.55 327.145 37.5 328.565 36.74C330.005 35.96 331.635 35.57 333.455 35.57C335.055 35.57 336.455 35.81 337.655 36.29C338.855 36.75 339.855 37.47 340.655 38.45L338.195 40.82C337.575 40.12 336.875 39.61 336.095 39.29C335.315 38.95 334.455 38.78 333.515 38.78C332.415 38.78 331.425 39.02 330.545 39.5C329.685 39.98 329.005 40.65 328.505 41.51C328.025 42.35 327.785 43.32 327.785 44.42C327.785 45.52 328.035 46.5 328.535 47.36C329.035 48.22 329.725 48.89 330.605 49.37C331.485 49.85 332.495 50.09 333.635 50.09C334.535 50.09 335.355 49.95 336.095 49.67C336.855 49.39 337.565 48.97 338.225 48.41L340.385 51.11ZM336.815 51.14V44.27H340.385V51.11L336.815 51.14ZM343.573 53V35.84H347.353V53H343.573ZM354.217 53V38.93H348.577V35.84H363.637V38.93H357.997V53H354.217ZM361.045 53L368.845 35.84H372.595L380.365 53H376.615L370.075 37.76H371.335L364.735 53H361.045ZM364.915 49.28L365.935 46.4H374.875L375.895 49.28H364.915ZM381.319 53V35.84H385.099V49.94H393.919V53H381.319ZM395.258 53V35.84H399.038V53H395.258ZM401.313 53V50.54L412.233 37.58L412.623 38.93H401.493V35.84H416.043V38.33L405.123 51.26L404.703 49.94H416.403V53H401.313ZM415.455 53L423.255 35.84H427.005L434.775 53H431.025L424.485 37.76H425.745L419.145 53H415.455ZM419.325 49.28L420.345 46.4H429.285L430.305 49.28H419.325ZM437.824 53V38.93H432.184V35.84H447.244V38.93H441.604V53H437.824ZM448.467 53V35.84H452.247V53H448.467ZM464.032 53.3C462.212 53.3 460.582 52.92 459.142 52.16C457.722 51.38 456.602 50.32 455.782 48.98C454.962 47.64 454.552 46.12 454.552 44.42C454.552 42.72 454.962 41.21 455.782 39.89C456.602 38.55 457.722 37.5 459.142 36.74C460.582 35.96 462.202 35.57 464.002 35.57C465.822 35.57 467.442 35.96 468.862 36.74C470.302 37.5 471.432 38.55 472.252 39.89C473.072 41.21 473.482 42.72 473.482 44.42C473.482 46.12 473.072 47.64 472.252 48.98C471.432 50.32 470.302 51.38 468.862 52.16C467.442 52.92 465.832 53.3 464.032 53.3ZM464.002 50.09C465.102 50.09 466.072 49.85 466.912 49.37C467.772 48.87 468.442 48.19 468.922 47.33C469.402 46.47 469.642 45.5 469.642 44.42C469.642 43.32 469.392 42.35 468.892 41.51C468.412 40.65 467.752 39.98 466.912 39.5C466.072 39.02 465.112 38.78 464.032 38.78C462.952 38.78 461.982 39.02 461.122 39.5C460.262 39.98 459.582 40.65 459.082 41.51C458.602 42.35 458.362 43.32 458.362 44.42C458.362 45.5 458.602 46.47 459.082 47.33C459.582 48.19 460.262 48.87 461.122 49.37C461.982 49.85 462.942 50.09 464.002 50.09ZM475.76 53V35.84H478.88L489.23 48.38H487.82V35.84H491.57V53H488.45L478.1 40.46H479.54V53H475.76Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg44);
export default __webpack_public_path__ + "static/media/44.7726830e60789589761aa3552a8f1633.svg";
export { ForwardRef as ReactComponent };